<script setup>
import MarketNoteMark from 'components/market/MarketNoteMark.vue';
import { computed } from 'vue';

const $props = defineProps({
    context: {
        type: String,
        default: null
    },
    dense: {
        type: Boolean,
        default: false
    },
    label: {
        type: String,
        required: true
    },
    note: {
        type: Number,
        default: null
    },
    unavailableMessage: {
        type: String,
        default: 'Data unavailable'
    },
    value: {
        type: [Number, String],
        default: null
    }
});

const isUnavailable = computed(() => {
    return $props.value === null || $props.value === undefined || $props.value === '';
});
</script>

<template>
    <article :aria-label="$props.label" class="market-metric-card column q-py-md">
        <span class="font-mono text-caption text-uppercase text-weight-medium text-hint">
            {{ $props.label }}<MarketNoteMark v-if="$props.note" :number="$props.note"/>
        </span>
        <strong v-if="!isUnavailable" :class="[ 'metric-value font-mono text-weight-medium q-mt-xs', $props.dense ? 'text-h4' : 'text-h3' ]">{{ $props.value }}</strong>
        <strong v-else class="text-subtitle1 text-weight-medium text-hint q-mt-sm">{{ $props.unavailableMessage }}</strong>
        <span v-if="$props.context" class="text-body2 text-hint q-mt-xs">{{ $props.context }}</span>
    </article>
</template>

<style lang="scss" scoped>
.market-metric-card {
    border-top: 2px solid rgba($primary, 0.4);

    .metric-value {
        line-height: 1.05;
    }
}
</style>
